<script setup lang="ts">
import { onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { IonContent, IonIcon, IonSpinner } from '@ionic/vue';
import { useI18n } from 'vue-i18n';
import { chevronBackOutline } from 'ionicons/icons';

import TopBar from '@/shared/components/TopBar.vue';
import searchUser from '@/modules/guest/composables/useGuestUser';
import { useAssetsStore } from '@/stores/shared/assetsStore';
import GuestWalletBox from '../components/GuestWalletBox.vue';

const { t } = useI18n();
const assetStore = useAssetsStore();
const router = useRouter();

const route = useRoute();
const loginToken = route.params.id.toString();

const { guestUserProfile, isSuccessGuestProfile, userMutate } = searchUser();

onMounted(async () => {
	userMutate({ login_token: loginToken });
});

const goBack = async () => {
	await router.push({ path: '/dashboard' });
};
</script>

<template>
	<ion-content>
		<TopBar class="px-[34px]">
			<template #left>
				<ion-button class="w-[35px] h-[35px] text-black ion-no-padding ion-no-margin hover:bg-white hover:rounded-full" shape="round" @click="goBack()">
					<ion-icon :icon="chevronBackOutline" class="ion-no-padding ion-no-margin text-black mr-[2px]"></ion-icon>
				</ion-button>
			</template>
			<template #center>
				<div class="flex justify-center w-full font-sourcesanspro-semibold text-l2">
					{{ t('guest_top_up.title') }}
				</div>
			</template>
		</TopBar>

		<div>
			<div class="px-[34px] icon flex justify-center mb-4">
				<img :src="assetStore.logoUrl" class="max-w-[70%]" />
			</div>
			<GuestWalletBox :user-profile="guestUserProfile" :is-success-profile="isSuccessGuestProfile" :login-token="loginToken"></GuestWalletBox>
		</div>
	</ion-content>
</template>

<style scoped></style>
